import { render, staticRenderFns } from "./SelectedAteco.vue?vue&type=template&id=460411b9&"
import script from "./SelectedAteco.vue?vue&type=script&lang=ts&"
export * from "./SelectedAteco.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports